import React from 'react';
import moment from 'moment';
import http from 'utils/http';
import exportFromJSON from 'export-from-json';
import ManageContracts from './ManageContracts';
import { setDeleteAction } from 'store/actions/deleteAction';
import { setDocAction } from 'store/actions/docAction';
import { connect } from 'react-redux';
// import events from 'utils/evemts';
import cloneDeep from 'lodash/cloneDeep';
import { appliedOnItems, LOCALE_OBJ, driversOptions, structureOptions } from 'custom/constants';
import { dateToUTC, getLocatDate } from 'utils/converter';
import cookies from 'utils/cookies';
import { toast } from 'react-toastify';
import { arrayMove, } from '@dnd-kit/sortable';

class ManageContractsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      attachment: false,
      modal: false,
      action: null,
      awb: null,
      docs: [],
      data: [],
      awbs: [],
      airlineList: [],
      filteredairlineList: [],
      combinationAirlines: [],
      contract: [],
      filteredData: [], 
      logs: [],
      airline: [],
      products: [],
      flight: [],
      measure: [],
      tab: 'active',
      searchOptions: {
        from: getLocatDate('YYYY-MM-DD'),
        to: getLocatDate('YYYY-MM-DD'),
      },
      search: {
        from: moment().format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
        f_time: '00:00',
        t_time: '23:59',
        awb: null,
      },
      filter: {
        airline: null,
        airlinecode: null,
        flight: null,
        measure: null,
        is_minimum: false,
        minimum_rate: null,

        controw_modaldata: {},  //Add Contract Line Item Add button
      },
      contractFieldEdit: {},
      recordOns: [],
      segments: [],
      controwField: {
        description: null,
        applied_on: null,
        is_product: false,
        productId: null,
        rate_type: 'stable',
        is_minimum: false,
        is_noncommercial: false,
        commercial_items: [],
        sheetlist: [],
        minimum: null,
        record_on: null,
        segment: 'N/A',
        remarks: '',
        roles: ['N/A'],
        platform: 'N/A',
        link_contract: false, // if controw had reference to other contract, set to true.
        refId: null,
        loadingaccessoriesId: null,
        minimum_on: 'airline',
      },
      commercial_options: [],
      contrateField: {
        rate: null,
        tier1: null,
        tier2: null,
        tier3: null,
        level1: null,
        level2: null,
        level3: null,
        level1low: 0,
        level2low: '-',
        level3low: '-',
        rate1: null,
        rate2: null,
        rate3: null,
        nolimit2: false,
        nolimit3: false,
      },
      dropdown_contracts: [], // list of contracts to link
      contractErrors: {},
      contractErrorsEdit: {},
      controwErrors: {},
      contrateErrors: {},

      searchFields: {},
      timer: null,
      sessionExpired: false,
      collapse: [],
      accessories: [],
      appliedOn: {
        drivers: '',
        structureType: '', // regular, airwaybill, total, none
        structure: '',
        productSpecific: '',
        productArray: 'none'
      },
      nonCommOpts: [],
    };
    this.spanRef = React.createRef();
    this.eventSource = null;
  }

  componentDidMount() {
    this.startTimer();
    this.fetchAccessories();
    this.fetchAirlines();
    // this.fetchContract();
    // this.eventSource = events('admin', 'contract');
    // this.eventSource.onmessage = (event) => {
    //   const msg = JSON.parse(event.data || '{}');
    //   if (msg.data && this.state.tab === 'active') {
    //     if (msg.action == 'add_contract') {
    //       this.setState({ contract: [...this.state.contract || [], msg.data] }, () => { this.sortcontrates(); });
    //     }
    //     if (msg.action == 'update_contract') {
    //       let contract = [...this.state.contract];
    //       const index = contract.findIndex(c => msg.data && c.id == msg.data.id);
    //       if (index > -1) {
    //         let contract_height = cloneDeep(contract[index].contract_height);
    //         msg.data.contractrows = contract[index].contractrows;
    //         contract[index] = { ...msg.data };
    //         contract[index].contract_height = contract_height || 0;
    //         this.setState({ contract }, () => { this.sortcontrates(); });
    //       }
    //     }
    //     if (msg.action == 'delete_contract') {
    //       let contract = [...this.state.contract];
    //       const index = contract.findIndex(c => msg.data && c.id == msg.data.id);
    //       if (index > -1) {
    //         contract.splice(index, 1);
    //         this.setState({ contract }, () => { this.sortcontrates(); });
    //       }
    //     }
    //     if (msg.action == 'add_controw') {
    //       const contract = [...this.state.contract];
    //       const index = contract.findIndex(c => msg.data && c.id == msg.data.contractId);
    //       if (index > -1) {
    //         contract[index].contractrows.push({ ...msg.data });
    //         let contract_height = contract[index].contract_height;
    //         contract_height = (contract_height || 0) + 1; // cont_row height
    //         contract[index].contract_height = contract_height;
    //         this.setState({ contract }, () => { this.sortcontrates(); });
    //       }
    //     }
    //     if (msg.action == 'update_controw') {
    //       const contract = [...this.state.contract];
    //       const index = contract.findIndex(c => msg.data && c.id == msg.data.contractId);
    //       if (index > -1) {
    //         const index2 = contract[index].contractrows.findIndex(cr => msg.data && cr.id == msg.data.id);
    //         if (index2 > -1) {
    //           msg.data.contrates = contract[index].contractrows[index2].contrates;
    //           contract[index].contractrows[index2] = { ...msg.data };
    //           this.setState({ contract }, () => { this.sortcontrates(); });
    //         }
    //       }
    //     }
    //     if (msg.action == 'delete_controw') {
    //       let contract = [...this.state.contract];
    //       const index = contract.findIndex(c => msg.data && c.id == msg.data.contractId);
    //       if (index > -1) {
    //         const index2 = contract[index].contractrows.findIndex(cr => msg.data && cr.id == msg.data.id);
    //         if (index2 > -1) {
    //           let contract_height = contract[index].contract_height;
    //           contract_height = contract_height - 1; // cont_row height
    //           contract[index].contract_height = contract_height;
    //           contract[index].contractrows.splice(index2, 1);
    //           this.setState({ contract }, () => { this.sortcontrates(); });
    //         }
    //       }
    //     }
    //     if (msg.action == 'add_contrate') {
    //       const contract = [...this.state.contract];
    //       const index = contract.findIndex(c => msg.data && c.id == msg.data.contractId);
    //       if (index > -1) {
    //         const index2 = contract[index].contractrows.findIndex(cr => msg.data && cr.id == msg.data.cont_rowId);
    //         if (index2 > -1) {
    //           if (contract[index].contractrows[index2].contrates.length !== 0) {
    //             let contract_height = contract[index].contract_height;
    //             contract_height = (contract_height || 0) + 1; // cont_row height
    //             contract[index].contract_height = contract_height;
    //           }
    //           msg.data.tier = msg?.data?.tier ? parseInt(msg?.data?.tier) : null;
    //           contract[index].contractrows[index2].contrates.push({ ...msg.data });
    //           this.setState({ contract }, () => { this.sortcontrates(); });
    //         }
    //       }
    //     }
    //     if (msg.action == 'update_contrate') {
    //       const contract = [...this.state.contract];
    //       const index = contract.findIndex(c => msg.data && c.id == msg.data.contractId);
    //       if (index > -1) {
    //         const index2 = contract[index].contractrows.findIndex(cr => msg.data && cr.id == msg.data.cont_rowId);
    //         if (index2 > -1) {
    //           const index3 = contract[index].contractrows[index2].contrates.findIndex(ct => msg.data && ct.id == msg.data.id);
    //           if (index3 > -1) {
    //             contract[index].contractrows[index2].contrates[index3] = { ...msg.data };
    //             this.setState({ contract }, () => { this.sortcontrates(); });
    //           }
    //         }
    //       }
    //     }
    //     if (msg.action == 'delete_contrate') {
    //       const contract = [...this.state.contract];
    //       const index = contract.findIndex(c => msg.data && parseInt(c.id) == parseInt(msg.data.contractId));
    //       if (index > -1) {
    //         const index2 = contract[index].contractrows.findIndex(cr => msg.data && cr.id == msg.data.cont_rowId);
    //         if (index2 > -1) {
    //           const index3 = contract[index].contractrows[index2].contrates.findIndex(ct => msg.data && ct.id == msg.data.id);
    //           if (index3 > -1) {
    //             let contract_height = contract[index].contract_height;
    //             if (contract[index].contractrows[index2].contrates.length !== 1) {
    //               contract_height = contract_height - 1; // cont_row height
    //               contract[index].contract_height = contract_height;
    //             }
    //             contract[index].contractrows[index2].contrates.splice(index3, 1);
    //             this.setState({ contract }, () => { this.sortcontrates(); });
    //           }
    //         }
    //       }
    //     }
    //     if (msg.action == 'add_doc') {
    //       let contract = [...this.state.contract];
    //       const index = contract.findIndex(c => msg.data && c.id == msg.data.contractId);
    //       if (index > -1) {
    //         contract[index].docs.push(msg.data);
    //         this.setState({ contract }, () => {
    //           this.handleDoc(contract[index]);
    //         });
    //       }
    //     }
    //     if (msg.action == 'delete_doc') {
    //       let contract = cloneDeep(this.state.contract);
    //       const index = contract.findIndex(c => msg.data && c.id == msg.data.contractId);
    //       if (index > -1) {
    //         const index2 = contract[index].docs.findIndex(cr => msg.data && cr.id == msg.data.id);
    //         if (index2 > -1) {
    //           contract[index].docs.splice(index2, 1);
    //           this.setState({ contract }, () => {
    //             this.handleDoc(contract[index]);
    //             this.filterContract();
    //           });
    //         }
    //       }
    //     }
    //   }
    // };
  }
  componentWillUnmount() {
    this.stopInterval();
    // this.eventSource.close();
  }

  startTimer = () => {
    if(cookies.get('expiryTimer')) {
      this.timer = setInterval(() => {
        const currentTime = moment.utc();
        const expirationTime = moment.utc(cookies.get('expiryTimer'));
        const timeDifference = expirationTime - currentTime;

        // Check if the timer has expired
        if (timeDifference <= 0) {
          cookies.remove('expiryTimer', { path: '/' });
          clearInterval(this.timer);
          this.setState({ sessionExpired: true });
          this.stopInterval();
        // Handle timer expiration
        } else {
        // Calculate remaining time
          const seconds = Math.floor((timeDifference / 1000) % 60) || 0;
          const minutes = Math.floor((timeDifference / 1000 / 60) % 60) || 0;
          const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24) || 0;
          const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24)) || 0;
          let sessionExpiryText = 'Session expires in ';
          let remainingTime = 0;
          if( (hours === 0 && minutes === 30 && seconds === 0 )|| (hours === 0 && minutes === 15 && seconds === 0)) {
            remainingTime = minutes;
            toast.warning(`${sessionExpiryText} ${remainingTime} minutes`);
          }
          this.setState({ timer: `Expires in ${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds` }
            // , ()=> {console.log(this.state.timer, 'timer');}
          );
        }
      }, 1000);
    }
  };

  stopInterval = () => {
    clearInterval(this.timer);
    clearInterval(this.state.timer);
    cookies.remove('expiryTimer', { path: '/' });
  };


  fetchAirlines = () => {
    http.get(`/airline?active=${true}`)
      .then((response) => {
        this.setState({ airlineList: response.data.data },()=> this.fetchAirlineCombination());
      });
  };
  fetchAirlineCombination = () => {
    http.get('/airline_combination?type=all')
      .then((response) => {
        const { data } = response;
        console.log('data.data', data.data);
        console.log('airlineList', this.state.airlineList);
        // remove the airlines from 
        const airlineList = this.state.airlineList.filter(airline => !data.data.some(combination => combination.airlineIds.includes(airline.id)));
        console.log('airlineList after filter', airlineList);
        this.setState({ 
          filteredairlineList: airlineList,
          combinationAirlines: data.data 
        },()=>this.fetchContract());
      });
  };
  fetchProducts = (row = {}) => {
    http.get(`/products?airlineId=${row === -1 ? 'ALL' : row || 'ALL'}&common=${true}`)
      .then(response => {
        const { data } = response;
        if (data.status === 'success') {
          if (data.data && data.data.length > 0) {
            this.setState({ products: data.data });
          } else {
            this.setState({ products: [] });
          }
        }
      })
      .catch(error => {
        this.setState({ products: [] });
        console.error('Error fetching data:', error);
      });
  };
  fetchContract = () => {
    http.get(`/contract?type=${this.state.tab}&date=${getLocatDate('YYYY-MM-DD')}`)
      .then(response => {
        const { data } = response;
        if (data.status === 'success') {
          //Need to go club up contracts by airlineCombinations.
          let contracts = [];
          data.data.map((contract, index) => {
            let contract_height = 0;
            if (contract.contractrows.length > 0) {
              contract_height = contract_height + (contract.contractrows.length);
              contract.contractrows.map((controw) => {
                if (controw?.contrates?.length > 0) {
                  contract_height = contract_height + (controw.contrates.length - 1);
                }
              });
            }
            data.data[index].contract_height = contract_height;
            contracts.push(data.data[index]);
          });
          this.setState({ contract: contracts }, () => { this.sortcontrates(); });
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  };

  fetchLogs = () => {
    this.setState({ contract: [] });
    http.get(`/change_log/contract?from=${dateToUTC(this.state.searchOptions.from+' 00:00', 'YYYY-MM-DD HH:mm')}&to=${dateToUTC(this.state.searchOptions.to+' 24:00', 'YYYY-MM-DD HH:mm')}`).then(({ data }) => {
      if (data.status == 'success') {
        this.setState({ logs: data.data });
      }
    }).catch(error => {
      console.error('Error fetching data:', error);
    });
  };

  fetchAccessories = (row = {}) => {
    const url = row?.airlineId || row?.airlineId === -1 ? `/loading_accessories?airlineId=${row.airlineId}` : '/loading_accessories';
    http.get(url)
      .then(response => {
        const { data } = response;
        if (data.status === 'success') {
          const accessories = data.data.map((accessory) => {
            return {
              ...accessory,
              value: `${accessory.description} | Manual`,
              label: `${accessory.description} | Manual`,
              desc: `This is the description of ${accessory.description} | Manual`,
              disable_product: true,
              rate_type_options: 'All',
              segments: ['Import', 'Export', 'Transit', 'Non-Transit'],
              recordOns: ['Outbound Flight Report'],
              loadingaccessoriesId: accessory.id,
            };
          });
          this.setState({ accessories });
        }
      })
      .catch(error => {
        this.setState({ accessories: [] });
        console.error('Error fetching data:', error);
      });
  };

  handleSearchOption = (event, type) => {
    let value = event.target ? event.target.value : event;
    // const name = event.target ? event.target.name : event;

    this.setState((prevState) => ({
      searchOptions: {
        ...prevState.searchOptions,
        [type]: value.format('YYYY-MM-DD')
      }
    }), () => {
      this.fetchLogs();
    });
  };

  onChangeContract = (e) => {
    this.setState((prev) => ({
      productField: {
        ...prev.productField,
        [e.target.name]: e.target.value
      }
    }));
  };

  onChangeTab = (e) => {
    if (e.target.value !== this.state.tab)
      this.setState({ tab: e.target.value }, () => {
        e.target.value == 'logs' ? this.fetchLogs() : this.fetchContract();
      });
  };

  validationContracts = () => {
    const contractFieldEdit = { ...this.state.contractFieldEdit };
    const error = {};
    let formValid = true;
    if (!contractFieldEdit.airline) {
      formValid = false;
      error.airline = true;
    }
    if (!contractFieldEdit.contract_type || (contractFieldEdit.contract_type.toString().trim().length === 0)) {
      formValid = false;
      error.contract_type = true;
    }
    if (!contractFieldEdit.start_date) {
      formValid = false;
      error.start_date = true;
    }
    if (!contractFieldEdit.end_date) {
      formValid = false;
      error.end_date = true;
    }
    this.setState({ contractErrorsEdit: error });
    return formValid;
  };

  validationContractsEdit = () => {
    const contractFieldEdit = { ...this.state.contractFieldEdit };
    const error = {};
    let formValid = true;
    if (!contractFieldEdit.airline) {
      formValid = false;
      error.airline = true;
    }
    if (!contractFieldEdit.contract_type || (contractFieldEdit.contract_type.toString().trim().length === 0)) {
      formValid = false;
      error.contract_type = true;
    }
    if (!contractFieldEdit.start_date) {
      formValid = false;
      error.start_date = true;
    }
    if (!contractFieldEdit.end_date) {
      formValid = false;
      error.end_date = true;
    }
    this.setState({ contractErrorsEdit: error });
    return formValid;
  };

  validationControws = () => {
    const controwField = { ...this.state.controwField };
    const contrateField = { ...this.state.contrateField };
    const error1 = {};
    const error2 = {};
    let formValid = true;
    if (controwField.is_noncommercial === true) {
      //validating non commercial item
      if (!controwField.description) {
        formValid = false;
        error1.description = 'Description is required.';
      }
      if (!controwField.commercial_items || controwField.commercial_items.length === 0) {
        formValid = false;
        error1.commercial_items = 'At least one commercial item is required.';
      }
      if (!controwField.sheetlist || controwField.sheetlist.length === 0) {
        formValid = false;
        error1.sheetlist = 'At least one non-commercial page is required.';
      }
    } else if(controwField.is_nonbillable === true) {
      //validating non billable item
      if (!controwField.description) {
        formValid = false;
        error1.description = true;
      }
      if (!controwField.applied_on) {
        formValid = false;
        error1.applied_on = true;
      }
      // if (!controwField.record_on && !controwField?.link_contract) {
      //   formValid = false;
      //   error1.record_on = true;
      // }
      if (!controwField.segment && !controwField?.link_contract) {
        formValid = false;
        error1.segment = true;
      }
      console.log('error1', error1);
    } else if(controwField.is_noncommercial === false) {
      if (!controwField.description) {
        formValid = false;
        error1.description = true;
      }
      if (!controwField.applied_on) {
        formValid = false;
        error1.applied_on = true;
      }
      if (!controwField.record_on && !controwField?.link_contract) {
        formValid = false;
        error1.record_on = true;
      }
      if (!controwField.segment && !controwField?.link_contract) {
        formValid = false;
        error1.segment = true;
      }
      if (controwField.rate_type === 'stable') {
        if (!contrateField.rate) {
          formValid = false;
          error2.rate = true;
        }
      } else if(controwField?.link_contract) {
        if (!controwField?.refId) {
          formValid = false;
          error1.refId = true;
        }
      } else {
        if ((contrateField.rate1?.trim() && !contrateField.level1?.trim()) || (!contrateField.rate1?.trim() && contrateField.level1?.trim())) {
          formValid = false;
          error2.level1 = true;
        }
        if ((contrateField.rate2?.trim() && !contrateField.level2?.trim() && !contrateField?.nolimit2 ) || (!contrateField.rate2?.trim() && contrateField.level2?.trim())) {
          formValid = false;
          error2.level2 = true;
        }
        if ((contrateField.rate3?.trim() && !contrateField.level3?.trim() && !contrateField?.nolimit3) || (!contrateField.rate3?.trim() && contrateField.level3?.trim())) {
          formValid = false;
          error2.level3 = true;
        }
        if(contrateField?.nolimit2 && !contrateField?.rate2?.trim()) {
          formValid = false;
          error2.level2 = true;
        }
        if(contrateField?.nolimit3 && !contrateField?.rate3?.trim()) {
          formValid = false;
          error2.level3 = true;
        }
        if (this.state.modal === 'contract_item' && this.state.action === 'edit') {
          const editingContractId = this.state.controwField?.sourceContractId || this.state.controw_modaldata?.id;
          let contract = this.state.contract.find(c => c.id == editingContractId);
          let controw = contract?.contractrows.find(cr => cr.id == this.state.controwField?.id);
          let tier1 = controw?.contrates.find(ct => ct.tier == 1);
          let tier2 = controw?.contrates.find(ct => ct.tier == 2);
          let tier3 = controw?.contrates.find(ct => ct.tier == 3);
          if ((!contrateField.rate1?.trim() && tier1?.rate) || (!contrateField.level1?.trim() && tier1?.level)) {
            formValid = false;
            error2.level1 = 'Cannot Clear Level and Rate values on Edit.';
          }
          if ((!contrateField.rate2?.trim() && tier2?.rate) || (!contrateField.level2?.trim() && tier2?.level)) {
            formValid = false;
            error2.level2 = 'Cannot Clear Level and Rate values on Edit.';
          }
          if ((!contrateField.rate3?.trim() && tier3?.rate) || (!contrateField.level3?.trim() && tier3?.level)) {
            formValid = false;
            error2.level3 = 'Cannot Clear Level and Rate values on Edit.';
          }
        }
        if (this.state.modal === 'commercial_item' && this.state.action === 'edit') {
          const editingContractId = this.state.controwField?.sourceContractId || this.state.controw_modaldata?.id;
          let contract = this.state.contract.find(c => c.id == editingContractId);
          let controw = contract?.contractrows.find(cr => cr.id == this.state.controwField?.id);
          let tier1 = controw?.contrates.find(ct => ct.tier == 1);
          let tier2 = controw?.contrates.find(ct => ct.tier == 2);
          let tier3 = controw?.contrates.find(ct => ct.tier == 3);
          if ((!contrateField.rate1?.trim() && tier1?.rate) || (!contrateField.level1?.trim() && tier1?.level)) {
            formValid = false;
            error2.level1 = 'Cannot Clear Level and Rate values on Edit.';
          }
          if ((!contrateField.rate2?.trim() && tier2?.rate) || (!contrateField.level2?.trim() && tier2?.level)) {
            formValid = false;
            error2.level2 = 'Cannot Clear Level and Rate values on Edit.';
          }
          if ((!contrateField.rate3?.trim() && tier3?.rate) || (!contrateField.level3?.trim() && tier3?.level)) {
            formValid = false;
            error2.level3 = 'Cannot Clear Level and Rate values on Edit.';
          }
        }
      }
    }
    this.setState({
      controwErrors: error1,
      contrateErrors: error2,
    });
    return formValid;
  };

  addContract = (e) => {
    e.preventDefault();
    let formdata = {
      airlineId: this.state.contractFieldEdit?.airline?.id,
      type: this.state.contractFieldEdit?.contract_type,
      is_minimum: this.state.contractFieldEdit?.is_minimum,
      minimum_rate: this.state.contractFieldEdit?.minimum_rate,
      start_date: this.state.contractFieldEdit?.start_date,
      end_date: this.state.contractFieldEdit?.end_date,
      mail: this.state.contractFieldEdit?.mail,
    };
    if (this.validationContracts()) {
      http.post('/contract', formdata).then(({ data }) => {
        if (data.status == 'success') {
          this.setState({
            modal: false,
            contractFieldEdit: {
              airline: null,
              airlinecode: null,
              contract_type: null,
              is_minimum: false,
              minimum: null,
            },
            contractErrors: {},
            action: null,
          },()=>{
            this.fetchContract();
          });
        }
      }).catch(error => {
        console.error('Error fetching data:', error);
      });
    }
  };

  editContracts = async (e) => {
    e.preventDefault();
    const airline = this.state.contractFieldEdit?.airline;
    const airlineId = Array.isArray(airline)
      ? airline.map((item) => item.id)
      : Array.isArray(airline?.airlines)
        ? airline.airlines.map((item) => item.id)
        : airline?.id;
    const formdata = {
      id: this.state.contractFieldEdit?.id,
      airlineId,
      type: this.state.contractFieldEdit?.contract_type,
      is_minimum: this.state.contractFieldEdit?.is_minimum,
      minimum_rate: this.state.contractFieldEdit?.minimum_rate,
      start_date: this.state.contractFieldEdit?.start_date,
      end_date: this.state.contractFieldEdit?.end_date,
      mail: this.state.contractFieldEdit?.mail,
    };

    if (this.validationContractsEdit()) {
      try {
        const { data } = await http.put('/contract/' + formdata.id, formdata);

        if (data.status === 'success') {
          this.setState({
            modal: false,
            contractFieldEdit: {},
            action: null,
          },()=>{
            this.fetchContract();
          });
        }
      } catch (error) {
        console.error('Error updating contract:', error);
      }
    }
  };

  deleteContract = async (id) => {
    await http.delete('/contract/' + id).then(({ data }) => {
      if (data.status == 'success') {
        this.props.setDelete();
        this.fetchContract();
      }
    }).catch(error => {
      console.error('Error fetching data:', error);
    });
  };

  addControw = async (e) => {
    e.preventDefault();
    const sourceContractId = this.state.controwField?.sourceContractId || this.state.controw_modaldata?.id;
    let rowformdata = {};
    if(this.state.controwField.is_noncommercial === true) {
      rowformdata = {
        description: this.state.controwField?.description,
        contract: sourceContractId,
        remarks: this.state.controwField?.remarks,
        is_noncommercial: true,
        commercial_items: this.state.controwField?.commercial_items,
        sheetlist: this.state.controwField?.sheetlist,
        is_nonbillable: true,
      };
    } else if (this.state.controwField.is_nonbillable === true) {
      rowformdata = {
        description: this.state.controwField?.description,
        applied_on: this.state.controwField?.applied_on,
        is_product: this.state.appliedOn.productSpecific === 'SPL' ? true : false,
        product: this.state.appliedOn.productSpecific === 'SPL' ? this.state.controwField?.productId : null,
        record_on: this.state.controwField?.record_on,
        segment: this.state.controwField?.segment,
        contract: sourceContractId,
        is_minimum: this.state.controwField?.is_minimum,
        minimum: this.state.controwField?.is_minimum ? this.state.controwField?.minimum : null,
        remarks: this.state.controwField?.remarks,
        roles: this.state.controwField?.roles,
        platform: this.state.controwField?.platform,
        refId: this.state.controwField?.refId,
        loadingaccessoriesId: this.state.controwField?.loadingaccessoriesId,
        is_noncommercial: false,
        commercial_items: [],
        sheetlist: [],
        exclude: this.state.controwField?.exclude || [],
        is_nonbillable: true,
      };
    }else {
      rowformdata = {
        description: this.state.controwField?.description,
        rate_type: this.state.controwField?.rate_type,
        applied_on: this.state.controwField?.applied_on,
        is_product: this.state.appliedOn.productSpecific === 'SPL' ? true : false,
        product: this.state.appliedOn.productSpecific === 'SPL' ? this.state.controwField?.productId : null,
        record_on: this.state.controwField?.record_on,
        segment: this.state.controwField?.segment,
        contract: sourceContractId,
        is_minimum: this.state.controwField?.is_minimum,
        minimum: this.state.controwField?.is_minimum ? this.state.controwField?.minimum : null,
        remarks: this.state.controwField?.remarks,
        roles: this.state.controwField?.roles,
        platform: this.state.controwField?.platform,
        refId: this.state.controwField?.refId,
        loadingaccessoriesId: this.state.controwField?.loadingaccessoriesId,
        is_noncommercial: false,
        commercial_items: [],
        sheetlist: [],
        exclude: this.state.controwField?.exclude || [],
        is_nonbillable: this.state.controwField?.is_nonbillable || false,
        minimum_on: this.state.controwField?.minimum_on,
      };
    }
    let rateformdata = {};
    let rates = [];
    if (this.state.controwField?.rate_type === 'stable') {
      let obj = {
        level: null,
        rate: this.state.contrateField?.rate,
        tier: null,
      };
      rates.push(obj);
    } else if(this.state.controwField?.link_contract) {
      //no need to push rates
    } else {
      let obj1 = {
        level: this.state.contrateField?.level1,
        rate: this.state.contrateField?.rate1,
        tier: 1,
      };
      let obj2 = {
        level: this.state.contrateField?.level2,
        rate: this.state.contrateField?.rate2,
        tier: 2,
        nolimit: this.state.contrateField?.nolimit2,
      };
      let obj3 = {
        level: this.state.contrateField?.level3,
        rate: this.state.contrateField?.rate3,
        tier: 3,
        nolimit: this.state.contrateField?.nolimit3,
      };
      rates.push(obj1);
      rates.push(obj2);
      rates.push(obj3);
    }
    rateformdata.rates = rates;
    const addRatePayloadsSnapshot = this.getCurrentControwRatePayloads();
    if (this.validationControws()) {
      http.post('/cont_row', rowformdata).then( async ({ data }) => {
        if (data.status == 'success') {
          if(rateformdata?.rates && rateformdata?.rates.length > 0) {
            await Promise.all(
              rateformdata?.rates.map(async (rate) => {
                rate.cont_row = data.data.id;
                rate.contractId = sourceContractId;
                await this.addContrate(e, rate);
              })
            ).then(async () => {
              // fetch contracts
              try {
                await this.syncAddedControwToPartner(sourceContractId, addRatePayloadsSnapshot);
              } catch (error) {
                console.error('Error syncing added driver to partner airline:', error);
                toast.warn('Driver added, but partner airline sync failed.');
              }
              this.setState({
                modal: false,
                recordOns: [],
                segments: [],
                controwField: {
                  description: null,
                  rate_type: 'stable',
                  applied_on: null,
                  is_product: false,
                  productId: null,
                  record_on: null,
                  segment: null,
                  is_minimum: false,
                  minimum: null,
                  roles: null,
                  platform: null,
                  refId: null,
                  loadingaccessoriesId: null,
                  link_contract: false,
                  is_noncommercial: false,
                  commercial_items: [],
                  sheetlist: [],
                  remarks: '',
                  exclude: [],
                  is_nonbillable: false,
                  minimum_on: 'airline',
                },
                contrateField: {
                  rate: null,
                  tier1: null,
                  tier2: null,
                  tier3: null,
                  level1: null,
                  level2: null,
                  level3: null,
                  rate1: null,
                  rate2: null,
                  rate3: null,
                  level1low: 0,
                  level2low: '-',
                  level3low: '-',
                  nolimit2: false,
                  nolimit3: false,
                },
                controwErrors: {},
                contrateErrors: {},
                action: null,
              });
              this.fetchContract();
            });
          } else {
            try {
              await this.syncAddedControwToPartner(sourceContractId, addRatePayloadsSnapshot);
            } catch (error) {
              console.error('Error syncing added driver to partner airline:', error);
              toast.warn('Driver added, but partner airline sync failed.');
            }
            this.setState({
              modal: false,
              recordOns: [],
              segments: [],
              controwField: {
                description: null,
                rate_type: 'stable',
                applied_on: null,
                is_product: false,
                productId: null,
                record_on: null,
                segment: null,
                is_minimum: false,
                minimum: null,
                roles: null,
                platform: null,
                refId: null,
                loadingaccessoriesId: null,
                link_contract: false,
                is_noncommercial: false,
                commercial_items: [],
                sheetlist: [],
                remarks: '',
                exclude: [],
                is_nonbillable: false,
                minimum_on: 'airline',
              },
              contrateField: {
                rate: null,
                tier1: null,
                tier2: null,
                tier3: null,
                level1: null,
                level2: null,
                level3: null,
                rate1: null,
                rate2: null,
                rate3: null,
                level1low: 0,
                level2low: '-',
                level3low: '-',
                nolimit2: false,
                nolimit3: false,
              },
              controwErrors: {},
              contrateErrors: {},
              action: null,
            });
            // fetch contracts
            this.fetchContract();
          }
        }
      }).catch(error => {
        console.error('Error fetching data:', error);
      });
    } else {
      console.log('failed to validate the form');
    }
  };

  editControw = async (e) => {
    e.preventDefault();
    const sourceContractId = this.state.controwField?.sourceContractId || this.state.controw_modaldata?.id;
    const shouldTryGroupedSignatureSync = !!this.state.controw_modaldata?.isGroupedContract && !this.state.controwField?.isCombinedRow;
    const originalSourceControw = this.getOriginalSourceControwForEdit();
    const groupedPartnerMatch = shouldTryGroupedSignatureSync && originalSourceControw
      ? this.findPartnerMatchingControw(this.state.controw_modaldata, originalSourceControw)
      : null;

    let rowformdata = {};
    if(this.state.controwField.is_noncommercial === true) {
      rowformdata = {
        description: this.state.controwField?.description,
        contract: sourceContractId,
        remarks: this.state.controwField?.remarks,
        is_noncommercial: true,
        commercial_items: this.state.controwField?.commercial_items,
        sheetlist: this.state.controwField?.sheetlist,
        is_nonbillable: true,
      };
    }else {
      rowformdata = {
        description: this.state.controwField?.description,
        rate_type: this.state.controwField?.rate_type,
        applied_on: this.state.controwField?.applied_on,
        is_product: this.state.appliedOn.productSpecific === 'SPL' ? true : false,
        product: this.state.appliedOn.productSpecific === 'SPL' ? this.state.controwField?.productId : null,
        record_on: this.state.controwField?.record_on,
        segment: this.state.controwField?.segment,
        contract: sourceContractId,
        is_minimum: this.state.controwField?.is_minimum,
        minimum: this.state.controwField?.is_minimum ? this.state.controwField?.minimum : null,
        remarks: this.state.controwField?.remarks && this.state.controwField?.remarks,
        roles: this.state.controwField?.roles,
        platform: this.state.controwField?.platform,
        refId: this.state.controwField?.refId,
        loadingaccessoriesId: this.state.controwField?.loadingaccessoriesId,
        is_noncommercial: false,
        commercial_items: [],
        sheetlist: [],
        exclude: this.state.controwField?.exclude || [],
        is_nonbillable: this.state.controwField?.is_nonbillable || false,
        minimum_on: this.state.controwField?.minimum_on,
      };
    }
    let cont_rate_ids = [];
    let rateformdata = {};
    let rates = [];
    if (this.state.controwField?.rate_type === 'stable') {
      let obj = {
        level: null,
        rate: this.state.contrateField?.rate,
        id: this.state.contrateField?.id,
        tier: null,
      };
      rates.push(obj);
      cont_rate_ids.push(this.state.contrateField?.id);
    } else if(this.state.controwField?.link_contract) {
      //no need to push rates
    } else {
      let obj1 = {
        level: this.state.contrateField?.level1,
        rate: this.state.contrateField?.rate1,
        id: this.state.contrateField?.id1,
        tier: 1,
      };
      let obj2 = {
        level: this.state.contrateField?.level2,
        rate: this.state.contrateField?.rate2,
        id: this.state.contrateField?.id2,
        tier: 2,
        nolimit: this.state.contrateField?.nolimit2,
      };
      let obj3 = {
        level: this.state.contrateField?.level3,
        rate: this.state.contrateField?.rate3,
        id: this.state.contrateField?.id3,
        tier: 3,
        nolimit: this.state.contrateField?.nolimit3,
      };
      rates.push(obj1);
      rates.push(obj2);
      rates.push(obj3);
      cont_rate_ids.push(this.state.contrateField?.id1);
      cont_rate_ids.push(this.state.contrateField?.id2);
      cont_rate_ids.push(this.state.contrateField?.id3);
    }
    rowformdata.cont_rate_ids = cont_rate_ids;
    rateformdata.rates = rates;
    if (this.validationControws()) {
      http.put(`/cont_row/${this.state.controwField.id}`, rowformdata).then(async ({ data }) => {
        if (data.status == 'success') {
          await Promise.all(
            rateformdata?.rates.map(async (rate) => {
              rate.cont_row = data.data.id;
              rate.contractId = data.data.contractId;
              if (rate?.id) {
                if (rate?.rate) {
                  await this.editContrate(e, rate);
                } else {
                  //throw error rate once set cannot be empty, delete the rate if not required
                }
              } else {
                await this.addContrate(e, rate);
              }
            })
          ).then(async () => {
            try {
              if (this.state.controwField?.isCombinedRow && this.state.controwField?.pairedControw?.id) {
                await this.syncPairedControwUpdate(rowformdata, this.state.controwField.pairedControw);
              } else if (groupedPartnerMatch?.partnerControw?.id) {
                await this.syncPairedControwUpdate(rowformdata, groupedPartnerMatch.partnerControw);
              }
            } catch (error) {
              console.error('Error syncing updated driver to partner airline:', error);
              toast.warn('Driver updated, but partner airline sync failed.');
            }

            // fetch contracts
            this.setState({
              modal: false,
              recordOns: [],
              segments: [],
              controwField: {
                description: null,
                rate_type: 'stable',
                applied_on: null,
                is_product: false,
                productId: null,
                record_on: null,
                segment: null,
                is_minimum: false,
                minimum: null,
                roles: null,
                platform: null,
                refId: null,
                loadingaccessoriesId: null,
                link_contract: false,
                is_nonbillable: false,
                exclude: [],
                minimum_on: 'airline',
              },
              contrateField: {
                rate: null,
                tier1: null,
                tier2: null,
                tier3: null,
                level1: null,
                level2: null,
                level3: null,
                rate1: null,
                rate2: null,
                rate3: null,
                level1low: 0,
                level2low: '-',
                level3low: '-',
                nolimit2: false,
                nolimit3: false,
              },
              controwErrors: {},
              contrateErrors: {},
              action: null,
            });
            this.fetchContract();
          });
          this.setState({
            modal: false,
            action: null,
          });
        }
      }).catch(error => {
        console.error('Error fetching data:', error);
      });
    } else {
      console.log('failed to validate the form');
    }
  };

  getCurrentControwRatePayloads = (includeIds = false) => {
    if (this.state.controwField?.is_noncommercial || this.state.controwField?.is_nonbillable || this.state.controwField?.link_contract) {
      return [];
    }

    if (this.state.controwField?.rate_type === 'stable') {
      const stableRatePayload = {
        level: null,
        rate: this.state.contrateField?.rate,
        tier: null,
      };

      if (includeIds) {
        stableRatePayload.id = this.state.contrateField?.id;
      }
      return stableRatePayload?.rate ? [stableRatePayload] : [];
    }

    const tieredRates = [
      {
        level: this.state.contrateField?.level1,
        rate: this.state.contrateField?.rate1,
        tier: 1,
        id: this.state.contrateField?.id1,
      },
      {
        level: this.state.contrateField?.level2,
        rate: this.state.contrateField?.rate2,
        tier: 2,
        nolimit: this.state.contrateField?.nolimit2,
        id: this.state.contrateField?.id2,
      },
      {
        level: this.state.contrateField?.level3,
        rate: this.state.contrateField?.rate3,
        tier: 3,
        nolimit: this.state.contrateField?.nolimit3,
        id: this.state.contrateField?.id3,
      },
    ];

    return tieredRates
      .filter((rate) => rate?.rate !== null && rate?.rate !== undefined && rate?.rate !== '')
      .map((rate) => {
        if (includeIds) return rate;
        const { id: _id, ...rateWithoutId } = rate;
        return rateWithoutId;
      });
  };

  buildCurrentControwForSignature = (sourceContractId, controwRates = null) => {
    return {
      ...this.state.controwField,
      contractId: sourceContractId,
      sourceContractId,
      is_product: this.state.appliedOn.productSpecific === 'SPL',
      productId: this.state.controwField?.productId || null,
      commercial_items: this.state.controwField?.commercial_items || [],
      sheetlist: this.state.controwField?.sheetlist || [],
      exclude: this.state.controwField?.exclude || [],
      contrates: controwRates || this.getCurrentControwRatePayloads(),
    };
  };

  getOriginalSourceControwForEdit = () => {
    const groupedSections = this.state.controw_modaldata?.groupedRowSections;
    const sourceContractId = parseInt(this.state.controwField?.sourceContractId || this.state.controw_modaldata?.id);
    const sourceControwId = parseInt(this.state.controwField?.id);

    if (!groupedSections || Number.isNaN(sourceControwId) || Number.isNaN(sourceContractId)) {
      return null;
    }

    const groupedRows = [
      ...(groupedSections?.combinedRows || []),
      ...(groupedSections?.airlineARows || []),
      ...(groupedSections?.airlineBRows || []),
    ];

    return groupedRows.find((row) => parseInt(row?.id) === sourceControwId && parseInt(row?.sourceContractId || row?.contractId) === sourceContractId) || null;
  };

  findPartnerMatchingControw = (contractItem = {}, sourceControw = {}) => {
    const partnerContractId = this.getGroupedPartnerContractId(contractItem, sourceControw);
    if (!partnerContractId) {
      return {
        partnerContractId: null,
        partnerControw: null,
      };
    }

    const partnerContract = this.state.contract.find((contract) => parseInt(contract?.id) === parseInt(partnerContractId));
    if (!partnerContract) {
      return {
        partnerContractId,
        partnerControw: null,
      };
    }

    const sourceSignature = this.getControwSignature(sourceControw);
    const partnerControw = (partnerContract?.contractrows || []).find((row) => this.getControwSignature(row) === sourceSignature) || null;
    return {
      partnerContractId,
      partnerControw,
    };
  };

  syncAddedControwToPartner = async (sourceContractId, controwRates = null) => {
    if (!this.state.controw_modaldata?.isGroupedContract) return;

    const sourceControw = this.buildCurrentControwForSignature(sourceContractId, controwRates);
    const { partnerContractId, partnerControw } = this.findPartnerMatchingControw(this.state.controw_modaldata, sourceControw);
    if (!partnerContractId || partnerControw) return;

    const partnerRowPayload = this.buildClonedControwPayload(sourceControw, partnerContractId);
    const rowResponse = await http.post('/cont_row', partnerRowPayload);
    if (rowResponse?.data?.status !== 'success' || !rowResponse?.data?.data?.id) {
      throw new Error('Partner airline controw add failed');
    }

    const partnerRowId = rowResponse.data.data.id;
    const ratePayloads = controwRates || this.getCurrentControwRatePayloads();
    await Promise.all(
      ratePayloads.map((rate) =>
        http.post('/cont_rate', {
          ...rate,
          cont_row: partnerRowId,
          contractId: partnerContractId,
        })
      )
    );
  };

  syncPairedControwUpdate = async (rowformdata, pairedControw = {}) => {
    if (!pairedControw?.id) return;

    const pairedContractId = pairedControw?.sourceContractId || pairedControw?.contractId;
    const pairedRowFormData = {
      ...rowformdata,
      contract: pairedContractId,
      cont_rate_ids: [],
    };

    const pairedRates = [];
    if (this.state.controwField?.rate_type === 'stable') {
      const stablePairRate = pairedControw?.contrates?.find((ct) => ct?.tier === null || ct?.tier === undefined) || pairedControw?.contrates?.[0];
      if (stablePairRate?.id) {
        pairedRowFormData.cont_rate_ids = [stablePairRate.id];
      }
      if (this.state.contrateField?.rate) {
        pairedRates.push({
          level: null,
          rate: this.state.contrateField?.rate,
          id: stablePairRate?.id,
          tier: null,
        });
      }
    } else if (!this.state.controwField?.link_contract && !this.state.controwField?.is_noncommercial && !this.state.controwField?.is_nonbillable) {
      const pairTier1 = pairedControw?.contrates?.find((ct) => parseInt(ct?.tier) === 1);
      const pairTier2 = pairedControw?.contrates?.find((ct) => parseInt(ct?.tier) === 2);
      const pairTier3 = pairedControw?.contrates?.find((ct) => parseInt(ct?.tier) === 3);

      pairedRowFormData.cont_rate_ids = [pairTier1?.id, pairTier2?.id, pairTier3?.id].filter(Boolean);
      const currentRates = this.getCurrentControwRatePayloads();
      currentRates.forEach((rate) => {
        if (parseInt(rate?.tier) === 1) {
          pairedRates.push({
            ...rate,
            id: pairTier1?.id,
          });
        } else if (parseInt(rate?.tier) === 2) {
          pairedRates.push({
            ...rate,
            id: pairTier2?.id,
          });
        } else if (parseInt(rate?.tier) === 3) {
          pairedRates.push({
            ...rate,
            id: pairTier3?.id,
          });
        }
      });
    }

    await http.put(`/cont_row/${pairedControw.id}`, pairedRowFormData);
    await Promise.all(
      pairedRates.map(async (rate) => {
        if (!rate?.id && !rate?.rate) return;
        if (rate?.id) {
          await http.put(`/cont_rate/${rate.id}`, {
            ...rate,
            cont_row: pairedControw.id,
            contractId: pairedContractId,
          });
        } else {
          await http.post('/cont_rate', {
            ...rate,
            cont_row: pairedControw.id,
            contractId: pairedContractId,
          });
        }
      })
    );
  };

  deleteControw = async (controw) => {
    let formdata = { contractId: controw.contractId };
    await http.put(`/cont_row_del/${controw.id}`, formdata).then(({ data }) => {
      if (data.status == 'success') {
        this.props.setDelete();
        //get contracts list 
        this.fetchContract();
      }
    }).catch(error => {
      console.error('Error fetching data:', error);
    });
  };

  addContrate = async (e, rateformdata) => {
    e.preventDefault();
    if (rateformdata.rate) {
      await http.post('/cont_rate', rateformdata).then(({ data }) => {
        if (data.status == 'success') {
          this.setState({
            modal: false,
            recordOns: [],
            segments: [],
            controwField: {
              description: null,
              rate_type: 'stable',
              applied_on: null,
              is_product: false,
              productId: null,
              record_on: null,
              segment: null,
              is_minimum: false,
              minimum: null,
              roles: null,
              platform: null,
              refId: null,
              loadingaccessoriesId: null,
              link_contract: false,
              is_nonbillable: false,
              minimum_on: 'airline',
            },
            contrateField: {
              rate: null,
              tier1: null,
              tier2: null,
              tier3: null,
              level1: null,
              level2: null,
              level3: null,
              rate1: null,
              rate2: null,
              rate3: null,
              level1low: 0,
              level2low: '-',
              level3low: '-',
              nolimit2: false,
              nolimit3: false,
            },
            controwErrors: {},
            contrateErrors: {},
            action: null,
          });
        }
      }).catch(error => {
        console.error('Error fetching data:', error);
      });
    }
  };

  editContrate = async (e, rateformdata) => {
    e.preventDefault();
    await http.put(`/cont_rate/${rateformdata?.id}`, rateformdata).then(({ data }) => {
      if (data.status == 'success') {
        this.setState({
          modal: false,
          recordOns: [],
          segments: [],
          controwField: {
            description: null,
            rate_type: 'stable',
            applied_on: null,
            is_product: false,
            productId: null,
            record_on: null,
            segment: null,
            is_minimum: false,
            minimum: null,
            roles: null,
            platform: null,
            refId: null,
            loadingaccessoriesId: null,
            link_contract: false,
            is_nonbillable: false,
            minimum_on: 'airline',
          },
          contrateField: {
            rate: null,
            tier1: null,
            tier2: null,
            tier3: null,
            level1: null,
            level2: null,
            level3: null,
            rate1: null,
            rate2: null,
            rate3: null,
            level1low: 0,
            level2low: '-',
            level3low: '-',
            nolimit2: false,
            nolimit3: false,
          },
          controwErrors: {},
          contrateErrors: {},
          action: null,
        });
      }
    }).catch(error => {
      console.error('Error fetching data:', error);
    });
  };

  deleteContrate = async (id, rowdata) => {
    let controw = cloneDeep(rowdata);
    let formdata = {
      cont_rowId: controw.id,
      contractId: controw.contractId,
    };
    await http.put(`/cont_rate_del/${id}`, formdata).then(({ data }) => {
      if (data.status == 'success') {
        this.props.setDelete();
        this.fetchContract();
        if (controw?.contrates && controw?.contrates.length === 1) {
          this.deleteControw(controw);
        }
      }
    }).catch(error => {
      console.error('Error fetching data:', error);
    });
  };

  cloneContractToPartner = async (e, item) => {
    e?.preventDefault?.();
    console.log('cloneContractToPartner', item);
    const partnerId = item?.airlineIds?.find((id) => id !== item.airlineId);
    if (!partnerId) {
      toast.error('Partner airline not found.');
      return;
    }

    const formdata = {
      ...item,
      airlineId: partnerId,
    };
    const failures = [];

    try {
      const { data } = await http.post('/contract', formdata);
      if (data.status !== 'success' || !data?.data?.id) {
        toast.error('Failed to clone contract to partner airline.');
        return;
      }

      const contractId = parseInt(data.data.id);
      const contractrows = [...(item?.contractrows || [])];

      for (const [rowIndex, controw] of contractrows.entries()) {
        try {
          const rowformdata = {
            ...this.buildClonedControwPayload(controw, contractId),
            contractId: contractId,
          };

          const rowResponse = await http.post('/cont_row', rowformdata);
          if (rowResponse?.data?.status !== 'success' || !rowResponse?.data?.data?.id) {
            failures.push(`cont_row failed at index ${rowIndex + 1}`);
            continue;
          }

          const createdControwId = parseInt(rowResponse.data.data.id);
          const shouldSkipRates = !!controw?.refId || !!controw?.link_contract;
          const ratePayloads = shouldSkipRates ? [] : this.getClonedRatePayloads(controw);

          if (ratePayloads.length > 0) {
            // Keep rate inserts parallel within the same row, but wait before next row.
            const rateResults = await Promise.allSettled(
              ratePayloads.map((rate) =>
                http.post('/cont_rate', {
                  ...rate,
                  cont_row: createdControwId,
                  contractId: contractId,
                })
              )
            );

            rateResults.forEach((result, rateIndex) => {
              if (result.status === 'rejected') {
                failures.push(`cont_rate failed at row ${rowIndex + 1}, rate ${rateIndex + 1}`);
                return;
              }
              if (result.value?.data?.status !== 'success') {
                failures.push(`cont_rate failed at row ${rowIndex + 1}, rate ${rateIndex + 1}`);
              }
            });
          }
        } catch (error) {
          console.error('Error fetching data:', error);
          failures.push(`cont_row failed at index ${rowIndex + 1}`);
        }
      }

      if (failures.length > 0) {
        console.warn('Contract clone completed with partial failures:', failures);
        toast.warning(`Contract cloned with ${failures.length} partial failures. Check console for details.`);
      } else {
        toast.success('Contract cloned successfully to partner airline.');
      }

      this.fetchContract();
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error('Failed to clone contract to partner airline.');
    }
  };

  fetchReport = (awb = false) => {
    let query = '';
    if (awb) {
      query = 'awb=' + this.state.search.awb;
    } else {
      query = `from=${this.state.search.from}&to=${this.state.search.to}&f_time=${this.state.search.f_time}&t_time=${this.state.search.t_time}`;
    }
    http.get('/reports?' + query).then(({ data }) => {
      if (data.status == 'success') {
        this.setState({
          data: data.data,
          filter: {
            airline: null,
            flight: null,
            measure: null
          }
        }, () => {
          this.getFilter();
          this.filterData();
        });
      }
    });
  };

  getFilter = () => {
    let airline = [];
    let flight = [];
    let measure = [];
    this.state.data.map(a => {
      let f = a.flight_no + '/' + moment(a.flight_date).format('DDMMMYY').toUpperCase();
      if (!flight.includes(f)) {
        flight.push(f);
      }
      if (a.airline) {
        if (!airline.includes(a.airline.code)) {
          airline.push(a.airline.code);
        }
      }
      a.screens.map(s => {
        if (s.measure) {
          if (!measure.includes(s.measure.type)) {
            measure.push(s.measure.type);
          }
        }
      });
    });
    this.setState({
      airline,
      flight,
      measure
    });
  };

  filterData = () => {
    let awbs = [...this.state.data || []];
    if (this.state.filter.airline && this.state.filter.airline != '') {
      awbs = awbs.filter((a) => a.airline.code === this.state.filter.airline);
    }
    if (this.state.filter.flight && this.state.filter.flight != '') {
      awbs = awbs.filter((a) => {
        let f = a.flight_no + '/' + moment(a.flight_date).format('DDMMMYY').toUpperCase();
        return f === this.state.filter.flight;
      });
    }
    if (this.state.filter.measure && this.state.filter.measure != '') {
      let filterAwbs = [];
      awbs.map(a => {
        let screens = [];
        a.screens.map(s => {
          if (s.measure.type == this.state.filter.measure) {
            screens.push(s);
          }
        });
        if (screens.length > 0) {
          filterAwbs.push({
            ...a,
            screens
          });
        }
      });
      awbs = filterAwbs;
    }

    this.setState({ awbs });
  };
  sortcontrates = () => {
    let contract = [...this.state.contract];
    // contract.sort((a, b) => a.airline?.name.localeCompare(b.airline?.name));
    contract.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    
    // Sort the 'controws' array within each 'contract' by 'rowname'
    contract.forEach((contractItem) => {
      contractItem.contractrows.sort((a, b) => a.position - b.position);
      // contractItem.contractrows.sort((a, b) => a.description.localeCompare(b.description));

      // // Sort the 'contrates' array within each 'controws' by 'ratename'
      // contractItem.contractrows.forEach((controwsItem) => {
      //   controwsItem.contrates.sort((a, b) => a.tier - b.tier);
      // });
    });
    this.setState({ contract }, () => { this.filterContract(); });
  };
  onChangeSearch = (e) => {
    let name = e.target.name;
    let value = e.target.type == 'checkbox' ? e.target.checked : e.target.value;
    if (e.target.type == 'date') {
      value = moment(e.target.value, 'DD-MM-YYYY').format('YYYY-MM-DD');
    }
    this.setState({
      search: {
        ...this.state.search,
        [name]: value
      }
    });
  };

  onChangefilter = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        [e.target.name]: e.target.value
      }
    }, () => { this.filterData(); });
  };

  onChangecontractFieldEdit = (e) => {
    const { name, value } = e.target;

    if (name === 'airline') {
    // Find a normal airline
      const airline = this.state.airlineList.find(
        (airline) => String(airline.id) === String(value)
      );

      // Find a combination
      const combination = this.state.combinationAirlines.find(
        (combination) =>
          combination.airlines.map((airline) => airline.id).join(',') ===
        String(value)
      );

      let selectedAirline = null;

      if (airline) {
      // Single airline
        selectedAirline = airline;
      } else if (combination) {
      // Combination of airlines
        selectedAirline = {
          id: value,
          name: combination.airlines
            .map((airline) => airline.name)
            .join(', '),
          code: combination.airlines
            .map((airline) => airline.code)
            .join('-'),
          airlines: combination.airlines,
        };
      }

      this.setState((prevState) => ({
        contractFieldEdit: {
          ...prevState.contractFieldEdit,
          airline: selectedAirline,
          airline_code: selectedAirline?.code || '',
        },
      }));

    } else if (name === 'is_minimum' || name === 'is_noncommercial') {
      this.setState((prevState) => ({
        contractFieldEdit: {
          ...prevState.contractFieldEdit,
          [name]: !prevState.contractFieldEdit[name],
        },
      }));

    } else {
      this.setState((prevState) => ({
        contractFieldEdit: {
          ...prevState.contractFieldEdit,
          [name]: value,
        },
      }));
    }
  };

  changeDateAndTime = (element, type) => {
    this.setState({
      contractFieldEdit: {
        ...this.state.contractFieldEdit,
        [type]: element.format('YYYY-MM-DD')
      }
    });
  };

  onChangecontrowField = (e) => {
    if (e.target.name === 'is_minimum' || e.target.name === 'is_product' || e.target.name === 'is_noncommercial') {
      this.setState({
        controwField: {
          ...this.state.controwField,
          [e.target.name]: !this.state.controwField[e.target.name],
          //reset rest of the fields if is_noncommercial is true
          ...(e.target.name === 'is_noncommercial' && e.target.checked ? {
            rate_type: 'stable',
            applied_on: null,
            is_product: false,
            productId: null,
            is_minimum: false,
            minimum: null,
            refId: null,
            loadingaccessoriesId: null,
            link_contract: false,
            is_nonbillable: false,
            minimum_on: 'airline',
          } : {})
        }
      });
    } else if (e.target.name === 'applied_on') {
      let combinedItems = this.props.buildUp ? [...appliedOnItems, ...this.state.accessories] : appliedOnItems;
      let item = combinedItems.find(item => item.value === e.target.value);
      // let item = appliedOnItems.find(item => item.value === e.target.value);
      this.setState({
        recordOns: item?.recordOns || [],
        segments: item?.segments || [],
        controwField: {
          ...this.state.controwField,
          ['applied_on']: e.target.value,
          ['is_product']: item?.disable_product ? false : this.state.controwField?.is_product,
          ['productId']: item?.disable_product ? null : this.state.controwField?.productId,
          ['rate_type_options']: item?.rate_type_options,
          ['rate_type']: 'stable',
          ['segment']: item?.segments[0]?.value || 'N/A',
          ['record_on']: item?.recordOns[0]?.value,
          ['roles']: e.target.value?.includes('Auto') ? ['N/A'] : this.state.controwField?.roles,
          ['link_contract']: false,
          ['refId']: null,
          ['loadingaccessoriesId']: item?.loadingaccessoriesId || null,
        }
      });
    } else if (e.target.name === 'link_contract') {
      this.setState({
        controwField: {
          ...this.state.controwField,
          ['link_contract']: !this.state.controwField.link_contract,
          ['refId']: null,
          ['segment']: null,
          ['record_on']: null,
          ['platform']: null,
        }
      });
    } else if (e.target.name === 'roles') {
      let controwField = this.state.controwField;
      controwField.roles = [e.target.value];
      this.setState({ controwField: controwField });
    } else if (e.target.name === 'record_on') {
      let controwField = this.state.controwField;
      controwField.record_on = e.target.value;
      controwField.platform = 'N/A';
      this.setState({ controwField: controwField });
    } else if (e.target.name === 'is_nonbillable'){
      let combinedItems = this.props.buildUp ? [...appliedOnItems, ...this.state.accessories] : appliedOnItems;
      let item = combinedItems.find(item => item.value === e.target.value);
      this.setState({
        controwField: {
          ...this.state.controwField,
          [e.target.name]: !this.state.controwField[e.target.name],
          ['rate_type_options']: item?.rate_type_options,
          ['rate_type']: 'stable',
          ['link_contract']: false,
          ['refId']: null,
        }
      });
    }
    else {
      this.setState({
        controwField: {
          ...this.state.controwField,
          [e.target.name]: e.target.value
        }
      });
    }

  };

  onChangecontrateField = (e) => {
    let value = e.target?.value.length > 0 && e.target.value.includes(',')? 
      e.target?.value?.replace(/,/g, '') : e.target.value;
    let name = e.target.name;
    this.setState({
      contrateField: {
        ...this.state.contrateField,
        [e.target.name]: value
      }
    },()=>{
      if(name.includes('level')){
        let level1 = this.state.contrateField?.level1 && this.state.contrateField?.level1.replace(/,/g, '');
        let level2 = this.state.contrateField?.level2 && this.state.contrateField?.level2.replace(/,/g, '');
        // let level3 = this.state.contrateField?.level3;
        let level1low = 0;
        let level2low = /*!level2 || isNaN(level2) ||*/ !level1 || isNaN(level1) ? '-' : (parseInt(level1)+parseInt(1));
        let level3low = /*!level3 || isNaN(level3) ||*/ !level2 || isNaN(level2) ? '-' : (parseInt(level2)+parseInt(1));
        this.setState({
          contrateField: {
            ...this.state.contrateField,
            ['level1low']: level1low,
            ['level2low']: level2low,
            ['level3low']: level3low,
          }
        });
      } else if (name === 'nolimit2') {
        // clear fields
        this.setState({
          contrateField: {
            ...this.state.contrateField,
            ['level2']: '',
            ['level3low']: '-',
            ['level3']: '',
            ['rate3']: '',
            ['nolimit3']: false,
          }
        });
      } else if (name === 'nolimit3') {
        // clear fields
        this.setState({
          contrateField: {
            ...this.state.contrateField,
            ['level3']: '',
          }
        });
      }
    });
  };

  handleNumberFormat = (value, name) => {
    let valueNew = value ? Number.parseFloat(value.replace(/,/g, '')).toLocaleString(LOCALE_OBJ.locale, LOCALE_OBJ.options) : '';
    if (name === 'minimum') {
      this.setState((prev) => ({
        controwField: {
          ...prev.controwField,
          [name]: valueNew
        }
      }));
    }
    else {
      this.setState((prev) => ({
        contrateField: {
          ...prev.contrateField,
          [name]: valueNew
        }
      }));
    }
  };

  handleOnFocus = (e, name) => {
    let value = e?.replace(/,/g, '');
    if (name === 'minimum') {
      this.setState((prev) => ({
        controwField: {
          ...prev.controwField,
          [name]: value
        }
      }));
    }
    else {
      this.setState((prev) => ({
        contrateField: {
          ...prev.contrateField,
          [name]: value
        }
      }));
    }
  };

  handlePopover = (attachment, anchorEl, awb, docs) => {
    this.setState({
      attachment,
      anchorEl,
      awb,
      docs
    });
  };

  handlePopoverClose = () => {
    this.setState({
      attachment: false,
      anchorEl: false
    });
  };

  handleDoc = (row) => {
    this.setState({ contractFieldEdit: { id: row.id } });
    this.props.setDoc({
      modal: 'contract',
      id: row.id,
      name: row.name,
      data: row.docs
    });
  };

  handleOpen = async (modal, action, data = {}, cont_row = {}) => {
    let dropdown_contracts = [];
    if(data?.contractrows && data?.contractrows.length > 0){
      await Promise.all(
        data.contractrows.map((row) => {
          if(row?.rate_type !== 'stable' && !row?.refId){
            let obj = {
              id: row.id,
              description: row.description,
              rate_type: row.rate_type
            };
            dropdown_contracts.push(obj);
          }
        })
      );
    }
    let commercial_options = [];
    if(data?.contractrows && data?.contractrows.length > 0){
      await Promise.all(
        data.contractrows.map((row) => {
          if((row?.is_noncommercial === false || !row?.is_noncommercial)&& !row?.refId){
            let obj = {
              id: row.id,
              description: row.description,
              rate_type: row.rate_type,
              key: row.id,
              is_nonbillable: row.is_nonbillable,
              is_noncommercial: row.is_noncommercial,
            };
            commercial_options.push(obj);
          }
        })
      );
    }
    if (modal === 'contract' && action === 'add') {
      let contractField = {
        id: null,
        airline: null,
        airlinecode: null,
        contract_type: null,
        is_minimum: false,
        minimum_rate: null,
        start_date: moment().format('DD MMM YY'),
        end_date: moment().format('DD MMM YY'),
        mail: null,
        is_noncommercial: false,
      };
      let contrateField = {
        ...this.state.contrateField,
        ['level1low']: 0,
      };
      this.setState({ 
        contractFieldEdit: contractField,
        contrateField: contrateField,
        dropdown_contracts: dropdown_contracts,
      });
    }
    else if (modal === 'contract_item' && action === 'edit') {
      let combinedItems = this.props.buildUp ? [...appliedOnItems, ...this.state.accessories] : appliedOnItems;
      let item2 = combinedItems.find(item => item.value === cont_row?.applied_on);
      // let item2 = appliedOnItems.find(item => item.value === cont_row?.applied_on);
      //get drivers from driversOptions where  cont_row?.applied_on.includes driversOptions value
      let driversArr = driversOptions.filter(driver => cont_row?.applied_on?.includes(driver.value));
      let drivers = null;
      if (driversArr.length > 0) {
        // Prioritize 'ULD' if present, otherwise use the first available driver
        const uldDriver = driversArr.find(driver => driver.value === 'ULD');
        drivers = uldDriver ? uldDriver.value : driversArr[0].value;
      }
      else drivers = (driversOptions.find(driver => cont_row?.applied_on?.includes(driver.value)))?.value || null;
      let appliedOn = this.state.appliedOn;
      let structureType = driversOptions.find(option => option.value === drivers)?.structureType || null;
      let structure = (structureOptions[structureType]?.find(driver => cont_row?.applied_on?.includes(driver.value)))?.value || null;
      let typeList = ['KGs', 'MD', 'LD3', 'LD7'];
      let type = '';
      if (drivers === 'ULD') {
        type = typeList.find(t => cont_row?.applied_on?.includes(t));
      }
      let productSpecific = cont_row?.applied_on?.includes('SPL') ? 'yes' : 'no';
      if(cont_row?.productId){
        productSpecific = 'SPL';
      }
      appliedOn.drivers = drivers;
      appliedOn.structure = structure;
      appliedOn.structureType = structureType || null;
      appliedOn.type = type || null;
      appliedOn.productSpecific = productSpecific || '';
      let controwField = {
        id: cont_row?.id,
        sourceContractId: cont_row?.sourceContractId || cont_row?.contractId || data?.id,
        sourceAirlineId: cont_row?.sourceAirlineId || data?.airlineId,
        sourceAirlineCode: cont_row?.sourceAirlineCode || data?.airline?.code,
        isCombinedRow: !!cont_row?.isCombinedRow,
        pairedControw: cont_row?.pairedControw || null,
        description: cont_row?.description,
        applied_on: cont_row?.applied_on,
        exclude: cont_row?.exclude ||[],
        is_product: cont_row?.is_product,
        productId: cont_row?.productId,
        rate_type: cont_row?.rate_type,
        is_minimum: cont_row?.is_minimum,
        minimum: cont_row?.minimum && cont_row?.minimum.replace(/,/g, ''),
        record_on: cont_row?.record_on,
        segment: cont_row?.segment,
        remarks: cont_row?.remarks,
        mail: cont_row?.mail,
        rate_type_options: item2?.rate_type_options,
        roles: cont_row.roles,
        platform: cont_row.platform,
        refId: cont_row.refId,
        loadingaccessoriesId: cont_row.loadingaccessoriesId,
        link_contract: cont_row.refId ? true : false,
        is_noncommercial: false,
        commercial_items: [],
        sheetlist: cont_row?.sheetlist || [],
        is_nonbillable: false,
        minimum_on: cont_row?.minimum_on || 'airline',
      };
      let contrateField = {};
      let cont_rates = cont_row?.contrates;
      if (cont_rates?.length > 0) {
        cont_rates.map((rate) => {
          // if(cont_rates?.length>1){
          if (cont_row.rate_type !== 'stable') {
            contrateField['id' + (rate.tier)] = rate.id;
            contrateField['rate' + (rate.tier)] = rate.rate;
            contrateField['level' + (rate.tier)] = rate.level;
            contrateField['tier' + (rate.tier)] = rate.tier;
            contrateField['nolimit' + (rate.tier)] = rate.nolimit;
          } else {
            contrateField.id = rate.id;
            contrateField.rate = rate.rate;
          }
        });
      }
      if (cont_row.rate_type !== 'stable') {
        let level1 = contrateField?.level1 && contrateField?.level1.replace(/,/g, '');
        let level2 = contrateField?.level2 && contrateField?.level2.replace(/,/g, '');
        // let level3 = contrateField.level3;
        let level1low = 0;
        let level2low = /*!level2 || isNaN(level2) ||*/ !level1 || isNaN(level1) ? '-' : (parseInt(level1)+parseInt(1));
        let level3low = /*!level3 || isNaN(level3) ||*/ !level2 || isNaN(level2) ? '-' : (parseInt(level2)+parseInt(1));
        contrateField= {
          ...contrateField,
          ['level1low']: level1low,
          ['level2low']: level2low,
          ['level3low']: level3low,
        };
      }
      let item = combinedItems.find(item => item.value === cont_row?.applied_on);
      // let item = appliedOnItems.find(item => item.value === cont_row?.applied_on);
      this.setState({
        controwField: controwField,
        contrateField: contrateField,
        segments: item?.segments || [],
        recordOns: item?.recordOns || [],
        dropdown_contracts: dropdown_contracts,
        appliedOn: appliedOn
      });
    } else if (modal === 'commercial_item' && action === 'edit') {
      let combinedItems = this.props.buildUp ? [...appliedOnItems, ...this.state.accessories] : appliedOnItems;
      let item2 = combinedItems.find(item => item.value === cont_row?.applied_on);
      // let item2 = appliedOnItems.find(item => item.value === cont_row?.applied_on);
      //get drivers from driversOptions where  cont_row?.applied_on.includes driversOptions value
      let driversArr = driversOptions.filter(driver => cont_row?.applied_on?.includes(driver.value));
      let drivers = null;
      if (driversArr.length > 0) {
        // Prioritize 'ULD' if present, otherwise use the first available driver
        const uldDriver = driversArr.find(driver => driver.value === 'ULD');
        drivers = uldDriver ? uldDriver.value : driversArr[0].value;
      }
      else drivers = (driversOptions.find(driver => cont_row?.applied_on?.includes(driver.value)))?.value || null;
      let appliedOn = this.state.appliedOn;
      let structureType = driversOptions.find(option => option.value === drivers)?.structureType || null;
      let structure = (structureOptions[structureType]?.find(driver => cont_row?.applied_on?.includes(driver.value)))?.value || null;
      let typeList = ['KGs', 'MD', 'LD3', 'LD7'];
      let type = '';
      if (drivers === 'ULD') {
        type = typeList.find(t => cont_row?.applied_on?.includes(t));
      }
      let productSpecific = cont_row?.applied_on?.includes('SPL') ? 'yes' : 'no';
      if(cont_row?.productId){
        productSpecific = 'SPL';
      }
      appliedOn.drivers = drivers;
      appliedOn.structure = structure;
      appliedOn.structureType = structureType || null;
      appliedOn.type = type || null;
      appliedOn.productSpecific = productSpecific || '';
      let controwField = {
        id: cont_row?.id,
        sourceContractId: cont_row?.sourceContractId || cont_row?.contractId || data?.id,
        sourceAirlineId: cont_row?.sourceAirlineId || data?.airlineId,
        sourceAirlineCode: cont_row?.sourceAirlineCode || data?.airline?.code,
        isCombinedRow: !!cont_row?.isCombinedRow,
        pairedControw: cont_row?.pairedControw || null,
        description: cont_row?.description,
        applied_on: cont_row?.applied_on,
        exclude: cont_row?.exclude ||[],
        is_product: cont_row?.is_product,
        productId: cont_row?.productId,
        rate_type: cont_row?.rate_type,
        is_minimum: cont_row?.is_minimum,
        minimum: cont_row?.minimum && cont_row?.minimum.replace(/,/g, ''),
        record_on: cont_row?.record_on,
        segment: cont_row?.segment,
        remarks: cont_row?.remarks,
        mail: cont_row?.mail,
        rate_type_options: item2?.rate_type_options,
        roles: cont_row.roles,
        platform: cont_row.platform,
        refId: cont_row.refId,
        loadingaccessoriesId: cont_row.loadingaccessoriesId,
        link_contract: cont_row.refId ? true : false,
        is_noncommercial: cont_row.is_noncommercial || false,
        commercial_items: cont_row?.commercial_items || [], 
        sheetlist: cont_row?.sheetlist || [],
        is_nonbillable: true,
        minimum_on: cont_row?.minimum_on || 'airline',
      };
      let nonCommOpts = [];
      if(cont_row?.commercial_items && cont_row?.commercial_items.length > 0){
        Promise.all(
          cont_row?.commercial_items.map((commItem) => {
            let obj = commercial_options.find(co => parseInt(co.id) === parseInt(commItem));
            if(obj){
              nonCommOpts.push(obj);
            }
          })
        );
      }
      let contrateField = {};
      let item = combinedItems.find(item => item.value === cont_row?.applied_on);
      // let item = appliedOnItems.find(item => item.value === cont_row?.applied_on);
      this.setState({
        controwField: controwField,
        nonCommOpts: nonCommOpts,
        contrateField: contrateField,
        segments: item?.segments || [],
        recordOns: item?.recordOns || [],
        dropdown_contracts: dropdown_contracts,
        commercial_options: commercial_options,
        appliedOn: appliedOn
      });
    } else if (modal === 'commercial_item' && action === 'add') {
      this.setState({ 
        controwField: {
          ...this.state.controwField,
          is_nonbillable: true,
        },
        commercial_options: commercial_options,
        nonCommOpts: [],
      });
    } else {
      let contractField = {
        id: data?.id,
        airline: data?.airline,
        airline_code: data?.airline?.code,
        contract_type: data?.type,
        is_minimum: data?.is_minimum,
        minimum_rate: data?.minimum,
        start_date: data?.start_date,
        end_date: data?.end_date,
        mail: data?.mail,
      };
      this.setState({ 
        contractFieldEdit: contractField,
        dropdown_contracts: dropdown_contracts,
        appliedOn: {
          drivers: '',
          structureType: '', // regular, airwaybill, total, none
          structure: '',
          productSpecific: '',
          productArray: 'none'
        },
        commercial_options: commercial_options,
      });
    }
    this.setState({
      modal,
      action,
      controw_modaldata: data,
      dropdown_contracts: dropdown_contracts
    }, () => {
      if (modal === 'contract_item') {
        this.fetchProducts(data?.airlineId);
        this.fetchAccessories(data);
      } else if (modal === 'commercial_item') {
        this.fetchProducts(data?.airlineId);
        this.fetchAccessories(data);
      }
    });
  };

  onClose = () => {
    this.setState({
      modal: false,
      sessionExpired: false,
      action: false,
      recordOns: [],
      segments: [],
      controwField: {
        description: null,
        rate_type: 'stable',
        applied_on: null,
        exclude: [],
        is_product: false,
        productId: null,
        record_on: null,
        segment: null,
        is_minimum: false,
        minimum: null,
        roles: null,
        platform: null,
        refId: null,
        loadingaccessoriesId: null,
        link_contract: false,
        is_noncommercial: false,
        commercial_items: [],
        sheetlist: [],
        is_nonbillable: false,
        minimum_on: 'airline',
      },
      contrateField: {
        rate: null,
        tier1: null,
        tier2: null,
        tier3: null,
        level1: null,
        level2: null,
        level3: null,
        rate1: null,
        rate2: null,
        rate3: null,
        level1low: 0,
        level2low: '-',
        level3low: '-',
        nolimit2: false,
        nolimit3: false,
      },
      controwErrors: {},
      contrateErrors: {},
      contractErrorsEdit: {},
      appliedOn: {},
    });
  };

  handleDelete = (type, id, item, anchorEl) => {
    this.props.setDelete({
      modal: true,
      id,
      anchorEl,
      onConfirm: () => {
        switch (type) {
          case 'contrate':
            this.deleteContrate(id, item);
            break;
          case 'controw':
            this.deleteControw(item);
            break;
          case 'contract':
            this.deleteContract(id);
            break;
          default:
            break;
        }
      },
    });
  };

  handleExport = () => {
    // let options = {
    //   fieldSeparator: ',',
    //   quoteStrings: '"',
    //   decimalSeparator: '.',
    //   showLabels: true,
    //   showTitle: false,
    //   filename: 'Screnning Report',
    //   useTextFile: false,
    //   useBom: false,
    //   useKeysAsHeaders: false,
    //   headers: ['AWB', 'PCS', 'ORG', 'DEST', 'Measure', 'Method', 'Screened For Flight', 'Screener', 'Screening Date/Time', 'Alarm', 'Resolution', 'Resolved', 'Remarks']
    // };
    let data = [];
    this.state.awbs.map(a => {
      a.screens.map(s => {
        data.push({
          awb: a.code + '-' + a.number,
          org: a.org,
          dest: a.dest,
          pcs: s.pcs,
          measure: s?.measure?.type,
          method: s?.method?.name,
          flight: s.flight_no + '/' + moment(screen.s).format('DDMMMYY').toUpperCase(),
          screener: s.user ? s.user.first_name + ' ' + s.user.last_name : s?.k9_company?.name,
          date: moment(s.screen_date).format('DDMMMYY').toUpperCase() + ' ' + s.screen_time,
          alarm: s.alarmed ? 'Yes' : 'No',
          resolution: s?.alarm?.name,
          resolved: s.resolved,
          remark: s.remark
        });
      });
    });
    exportFromJSON({
      data,
      fileName: 'Screnning Report',
      exportType: 'csv'
    });
  };

  onChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState((prev) => ({
      searchFields: {
        ...prev.searchFields,
        [name]: value
      }
    }), () => this.filterContract()
    );
  };

  normalizeControwValue = (value) => {
    if (value === null || value === undefined) return '';
    if (typeof value === 'number') return value.toString();
    return value.toString().trim();
  };

  getNormalizedContrates = (contrates = []) => {
    return [...(contrates || [])]
      .map((rate) => ({
        tier: rate?.tier ?? null,
        level: this.normalizeControwValue(rate?.level),
        rate: this.normalizeControwValue(rate?.rate || rate?.rate_dec),
        nolimit: !!rate?.nolimit,
      }))
      .sort((a, b) => {
        const tierA = a.tier === null ? -1 : parseInt(a.tier);
        const tierB = b.tier === null ? -1 : parseInt(b.tier);
        return tierA - tierB;
      });
  };

  getControwSignature = (row = {}) => {
    const normalized = {
      description: this.normalizeControwValue(row?.description),
      rate_type: this.normalizeControwValue(row?.rate_type),
      applied_on: this.normalizeControwValue(row?.applied_on),
      is_product: !!row?.is_product,
      productId: row?.productId ?? null,
      is_minimum: !!row?.is_minimum,
      minimum: this.normalizeControwValue(row?.minimum),
      record_on: this.normalizeControwValue(row?.record_on),
      segment: this.normalizeControwValue(row?.segment),
      remarks: this.normalizeControwValue(row?.remarks),
      roles: [...(row?.roles || [])].map((role) => this.normalizeControwValue(role)).sort(),
      platform: this.normalizeControwValue(row?.platform),
      refId: row?.refId ?? null,
      loadingaccessoriesId: row?.loadingaccessoriesId ?? null,
      is_noncommercial: !!row?.is_noncommercial,
      is_nonbillable: !!row?.is_nonbillable,
      commercial_items: [...(row?.commercial_items || [])].map((id) => parseInt(id)).sort((a, b) => a - b),
      sheetlist: [...(row?.sheetlist || [])].map((item) => this.normalizeControwValue(item)).sort(),
      exclude: [...(row?.exclude || [])].map((item) => this.normalizeControwValue(item)).sort(),
      contrates: this.getNormalizedContrates(row?.contrates || []),
    };
    return JSON.stringify(normalized);
  };

  getContractHeight = (rows = []) => {
    let contractHeight = 0;
    if (rows.length > 0) {
      contractHeight = contractHeight + rows.length;
      rows.forEach((controw) => {
        if (controw?.contrates?.length > 0) {
          contractHeight = contractHeight + (controw.contrates.length - 1);
        }
      });
    }
    return contractHeight;
  };

  getGroupedPartnerContractId = (contractItem = {}, controw = {}) => {
    const sourceContractId = parseInt(controw?.sourceContractId || controw?.contractId);
    const groupedIds = [...(contractItem?.groupedContractIds || [])]
      .map((id) => parseInt(id))
      .filter((id) => !Number.isNaN(id));

    if (Number.isNaN(sourceContractId) || groupedIds.length < 2) return null;
    return groupedIds.find((id) => id !== sourceContractId) || null;
  };

  buildClonedControwPayload = (controw = {}, targetContractId) => {
    const productId = controw?.productId || controw?.product?.id || null;

    if (controw?.is_noncommercial === true) {
      return {
        description: controw?.description,
        contract: targetContractId,
        remarks: controw?.remarks,
        is_noncommercial: true,
        commercial_items: controw?.commercial_items || [],
        sheetlist: controw?.sheetlist || [],
        is_nonbillable: true,
      };
    }

    if (controw?.is_nonbillable === true) {
      return {
        description: controw?.description,
        applied_on: controw?.applied_on,
        is_product: !!controw?.is_product,
        product: controw?.is_product ? productId : null,
        record_on: controw?.record_on,
        segment: controw?.segment,
        contract: targetContractId,
        is_minimum: !!controw?.is_minimum,
        minimum: controw?.is_minimum ? controw?.minimum : null,
        remarks: controw?.remarks,
        roles: controw?.roles,
        platform: controw?.platform,
        refId: controw?.refId,
        loadingaccessoriesId: controw?.loadingaccessoriesId,
        is_noncommercial: false,
        commercial_items: [],
        sheetlist: [],
        exclude: controw?.exclude || [],
        is_nonbillable: true,
      };
    }

    return {
      description: controw?.description,
      rate_type: controw?.rate_type,
      applied_on: controw?.applied_on,
      is_product: !!controw?.is_product,
      product: controw?.is_product ? productId : null,
      record_on: controw?.record_on,
      segment: controw?.segment,
      contract: targetContractId,
      is_minimum: !!controw?.is_minimum,
      minimum: controw?.is_minimum ? controw?.minimum : null,
      remarks: controw?.remarks,
      roles: controw?.roles,
      platform: controw?.platform,
      refId: controw?.refId,
      loadingaccessoriesId: controw?.loadingaccessoriesId,
      is_noncommercial: false,
      commercial_items: [],
      sheetlist: [],
      exclude: controw?.exclude || [],
      is_nonbillable: !!controw?.is_nonbillable,
    };
  };

  getClonedRatePayloads = (controw = {}) => {
    if (controw?.is_noncommercial || controw?.is_nonbillable || controw?.link_contract) {
      return [];
    }

    if (controw?.rate_type === 'stable') {
      const stableRate = controw?.contrates?.find((ct) => ct?.tier === null || ct?.tier === undefined) || controw?.contrates?.[0];
      if (!stableRate?.rate && !stableRate?.rate_dec) return [];
      return [{
        level: null,
        rate: stableRate?.rate || stableRate?.rate_dec,
        tier: null,
      }];
    }

    return [...(controw?.contrates || [])]
      .map((rate) => ({
        level: rate?.level,
        rate: rate?.rate || rate?.rate_dec,
        tier: rate?.tier ?? null,
        nolimit: !!rate?.nolimit,
      }))
      .filter((rate) => rate?.rate !== null && rate?.rate !== undefined && rate?.rate !== '');
  };

  cloneControwToPartner = async (contractItem, controw) => {
    if (!contractItem?.isGroupedContract || controw?.isCombinedRow) return;

    const targetContractId = this.getGroupedPartnerContractId(contractItem, controw);
    if (!targetContractId) {
      toast.error('Partner airline contract not found for this row.');
      return;
    }

    const sourceSignature = this.getControwSignature(controw);
    const partnerContract = this.state.contract.find((contract) => parseInt(contract?.id) === parseInt(targetContractId));
    const hasDuplicate = (partnerContract?.contractrows || []).some((row) => this.getControwSignature(row) === sourceSignature);
    if (hasDuplicate) {
      const confirmCreate = window.confirm('Same driver already exists in the partner airline. Create another copy?');
      if (!confirmCreate) return;
    }

    try {
      const rowformdata = this.buildClonedControwPayload(controw, targetContractId);
      const rowResponse = await http.post('/cont_row', rowformdata);
      if (rowResponse?.data?.status !== 'success' || !rowResponse?.data?.data?.id) {
        toast.error('Unable to create driver for partner airline.');
        return;
      }

      const createdRowId = rowResponse.data.data.id;
      const ratePayloads = this.getClonedRatePayloads(controw);

      await Promise.all(
        ratePayloads.map((rate) =>
          http.post('/cont_rate', {
            ...rate,
            cont_row: createdRowId,
            contractId: targetContractId,
          })
        )
      );

      toast.success('Driver copied to partner airline.');
      this.fetchContract();
    } catch (error) {
      console.error('Error cloning driver to partner airline:', error);
      toast.error('Failed to copy driver to partner airline.');
    }
  };

  getGroupedRowSections = (contracts = []) => {
    if (!contracts || contracts.length < 2) return null;

    const [firstContract, secondContract] = contracts;
    const firstRows = [...(firstContract?.contractrows || [])];
    const secondRows = [...(secondContract?.contractrows || [])];
    const secondRowsBySignature = {};

    secondRows.forEach((row) => {
      const signature = this.getControwSignature(row);
      if (!secondRowsBySignature[signature]) {
        secondRowsBySignature[signature] = [];
      }
      secondRowsBySignature[signature].push(row);
    });

    const combinedRows = [];
    const airlineARows = [];

    firstRows.forEach((row) => {
      const signature = this.getControwSignature(row);
      const partnerRows = secondRowsBySignature[signature] || [];
      if (partnerRows.length > 0) {
        const partnerRow = partnerRows.shift();
        combinedRows.push({
          ...row,
          sourceContractId: row?.contractId || firstContract?.id,
          sourceAirlineId: firstContract?.airlineId,
          sourceAirlineCode: firstContract?.airline?.code,
          isCombinedRow: true,
          pairedControw: {
            ...partnerRow,
            sourceContractId: partnerRow?.contractId || secondContract?.id,
            sourceAirlineId: secondContract?.airlineId,
            sourceAirlineCode: secondContract?.airline?.code,
          }
        });
      } else {
        airlineARows.push({
          ...row,
          sourceContractId: row?.contractId || firstContract?.id,
          sourceAirlineId: firstContract?.airlineId,
          sourceAirlineCode: firstContract?.airline?.code,
          isCombinedRow: false,
        });
      }
    });

    const airlineBRows = [];
    Object.keys(secondRowsBySignature).forEach((signature) => {
      secondRowsBySignature[signature].forEach((row) => {
        airlineBRows.push({
          ...row,
          sourceContractId: row?.contractId || secondContract?.id,
          sourceAirlineId: secondContract?.airlineId,
          sourceAirlineCode: secondContract?.airline?.code,
          isCombinedRow: false,
        });
      });
    });

    return {
      combinedRows,
      airlineARows,
      airlineBRows,
      airlineA: firstContract?.airline,
      airlineB: secondContract?.airline,
    };
  };

  filterContract = () => {
    const isCombinationContract = (contract) => {
      const value = contract?.is_combination;
      return value === true || value === 1 ||
        (typeof value === 'string' && ['1', 'true'].includes(value.trim().toLowerCase()));
    };
    let filteredData = [...this.state.contract];
    if (this.state.searchFields.airline && this.state.searchFields.airline != 'All') {
      const selectedAirline = this.state.searchFields.airline;
      if (typeof selectedAirline === 'string' && selectedAirline.includes(',')) {
        const selectedAirlineIds = selectedAirline.split(',').map((id) => id.trim());
        filteredData = filteredData.filter((list) => (
          isCombinationContract(list) &&
          selectedAirlineIds.includes(String(list?.airlineId ?? list?.airline?.id))
        ));
      } else {
        filteredData = filteredData.filter((list) => {
          return !isCombinationContract(list) &&
            String(list?.airlineId ?? list?.airline?.id) === String(selectedAirline);
        });
      }
    }
    else if (this.state.searchFields.airline === 'All') {
      filteredData = filteredData.filter((item, index, self) => self.indexOf(item) === index);
    }

    const groupedCandidates = {};
    const standaloneContracts = [];

    filteredData.forEach((item) => {
      if (!isCombinationContract(item) || !item.combination_key) {
        standaloneContracts.push(item);
        return;
      }

      const groupKey = `${item.combination_key}|${item.type}|${item.start_date}|${item.end_date}`;
      if (!groupedCandidates[groupKey]) {
        groupedCandidates[groupKey] = { contracts: [] };
      }
      groupedCandidates[groupKey].contracts.push(item);
    });

    const mergedContracts = [];
    Object.keys(groupedCandidates).forEach((key) => {
      const groupedData = groupedCandidates[key];
      const contracts = groupedData?.contracts || [];

      // Group only when partner contracts exist with same combination/type/date.
      if (contracts.length > 1) {
        const baseContract = contracts[0];
        const allContractRows = [];
        const groupedContractIds = [];
        const groupedAirlineIds = [];
        const groupedRowSections = this.getGroupedRowSections(contracts);
        const airlineIds = contracts.map((contract) => contract.airlineId);
        const airlines = contracts.map((contract) => contract.airline);

        contracts.forEach((contract) => {
          allContractRows.push(...(contract.contractrows || []));
          groupedContractIds.push(contract.id);
          groupedAirlineIds.push(contract.airlineId);
        });
        mergedContracts.push({
          ...baseContract,
          airlineIds,
          airline: airlines,
          contractrows: allContractRows,
          contract_height: this.getContractHeight(allContractRows),
          groupedContractIds,
          groupedAirlineIds,
          groupedRowSections,
          isGroupedContract: true,
        });
      } else {
        mergedContracts.push(contracts[0]);
      }
    });
    filteredData = [...standaloneContracts, ...mergedContracts];

    let firstCollapse = null;
    if (this.state.collapse.length === 0) {
      for (const item of filteredData) {
        if (item.contractrows.length > 0) {
          firstCollapse = item.id;
          break;
        }
      }
      this.setState({ collapse: [firstCollapse] });
    }
    this.setState({ filteredData: filteredData, });
  };

  handleTableCollapse = (id) => {
    let collapse = this.state.collapse || [];
    if(collapse?.includes(id)) {
      const index = collapse?.indexOf(id);
      if (index > -1) { 
        collapse?.splice(index, 1);
      }
    }
    else collapse.push(id);
    this.setState({ collapse }); 
  };

  handleDragEnd = (event, row) => {
    const { active, over } = event;
    if (active && over && active.id !== over.id) {
      const oldIndex = row.findIndex((item) => item.id === active.id);
      const newIndex = row.findIndex((item) => item.id === over.id);
      let index = row[0].contractId;
      let contractIndex = this.state.filteredData.findIndex((item) => item.id === index);
      this.setState((prevState) => {
        const updatedFilteredData = [...prevState.filteredData];
        updatedFilteredData[contractIndex] = {
          ...updatedFilteredData[contractIndex],
          contractrows: arrayMove(
            updatedFilteredData[contractIndex].contractrows,
            oldIndex,
            newIndex
          ),
        };
        return { filteredData: updatedFilteredData };
      }, () => {
        let positions = [];
        this.state.filteredData[contractIndex].contractrows.map((row, index) => {
          let obj = {
            id: row.id,
            position: index,
          };
          positions.push(obj);
        });
        let formdata = { positions: positions, };
        http.post('/cont_row/position', formdata).then(({ data }) => {
          if (data.status == 'success') {
            //success
          }
        }).catch(error => {
          console.error('Error fetching data:', error);
        });
      });
    }
  };

  handleRemark = (modal, data) => {
    this.setState({
      modal,
      modalData: data
    });
  };

  handleRemarkClose = () => {
    this.setState({
      modal: false,
      modalData: null
    });
  };

  handleRadioChange = (e) => { 
    let name = e.target.name;
    let value = e.target.value;
    let structureType = driversOptions.find(option => option.value === value)?.structureType || null;
    let structure = this.state.appliedOn.structure;
    let productSpecific = name === 'productSpecific' ? value : this.state.appliedOn.productSpecific;
    // name = drivers && manual
    if (name === 'drivers' && value === 'units') {
      this.setState(() => ({
        appliedOn: {
          drivers: value,
          productSpecific: '',
          structure: '',
          structureType: structureType,
          type: '',
        },
        recordOns: [],
        controwField: {
          ...this.state.controwField,
          productId: null
        }
      }, () => {
        // get applied on from appliedOnItems using appliedOn.driver and appliedOn.structure
        let appliedOnVal = appliedOnItems.find(item => item.value.includes(value) && item.value.includes(structureType)) || null;
        this.setState({
          controwField: {
            ...this.state.controwField,
            applied_on: appliedOnVal?.value
          },
          recordOns: appliedOnVal?.recordOns || this.state.recordOns
        });
      }));
    } else {  // name = anything
      if(name === 'drivers'){
        structure = ((structureOptions[structureType]?.[0])?.value) || null;
      }
      this.setState({
        appliedOn: {
          ...this.state.appliedOn,
          [name]: value,
          structureType: name === 'drivers' ? structureType : this.state.appliedOn.structureType,
          structure: name === 'structure' ? value : structure,
          type: name === 'structure' && value ==='Intact' ? 'Total' : name === 'type' ? value : '',
          productSpecific: name !== 'productSpecific' ? '' : productSpecific,
          // type:
        },
        recordOns: [],
        controwField: {
          ...this.state.controwField,
          productId: null
        }
      }, () => {
        // get applied on from appliedOnItems using appliedOn.driver and appliedOn.structure
        // let appliedOnValarr = appliedOnItems.filter(item => item.value.includes(this.state.appliedOn.drivers) && item.value.includes(this.state.appliedOn.structure));
        // console.log('appliedOnValarr', appliedOnValarr);
        let appliedOnVal = null;
        if(this.state.appliedOn.structureType === 'none'){
          this.setState({
            appliedOn: {
              ...this.state.appliedOn,
              type: ''
            }
          });
          appliedOnVal = appliedOnItems.find(item => item.value.includes(this.state.appliedOn.drivers));
        } else {
          if(this.state.appliedOn.type){
            if(this.state.appliedOn.productSpecific === 'SPL' || this.state.appliedOn.productSpecific === 'Gen'){
              appliedOnVal = appliedOnItems.find(item => item.value.includes(this.state.appliedOn.drivers) &&
                item.value.includes(this.state.appliedOn.structure) &&
                item.value.includes(this.state.appliedOn.type) && 
                (item.value.includes(this.state.appliedOn.productSpecific))
              ) || null;
            } else {
              appliedOnVal = appliedOnItems.find(item => item.value.includes(this.state.appliedOn.drivers) && 
                item.value.includes(this.state.appliedOn.structure) && 
                item.value.includes(this.state.appliedOn.type)
              ) || null;
            }
          } else {
            if(this.state.appliedOn.productSpecific === 'SPL' || this.state.appliedOn.productSpecific === 'Gen'){
              appliedOnVal = appliedOnItems.find(item => item.value.includes(this.state.appliedOn.drivers) && 
              item.value.includes(this.state.appliedOn.structure) && (item.value.includes(this.state.appliedOn.productSpecific))) || null;
            } else {
              if(this.state.appliedOn.drivers === 'ULD' && this.state.appliedOn.structure === 'Total'){
                appliedOnVal = appliedOnItems.find(item => item.value.includes('Total ULDs')) || null;
              } else {
                appliedOnVal = appliedOnItems.find(item => item.value.includes(this.state.appliedOn.drivers) && item.value.includes(this.state.appliedOn.structure))  || null;
              }
            }
          }
        }
        // appliedOnItems.find(item => item.value.includes(this.state.appliedOn.drivers) && item.value.includes(this.state.appliedOn.structure))?.value 
        // : appliedOnItems.find(item => item.value.includes(this.state.appliedOn.drivers)?.value)
        // || null;
        let combinedItems = this.props.buildUp ? [...appliedOnItems, ...this.state.accessories] : appliedOnItems;
        let item = combinedItems.find(item => item.value === appliedOnVal?.value);
        this.setState({ 
          controwField: {
            ...this.state.controwField,
            applied_on: appliedOnVal?.value,
            ['is_product']: item?.disable_product ? false : this.state.controwField?.is_product,
            ['productId']: item?.disable_product ? null : this.state.controwField?.productId,
            ['rate_type_options']: item?.rate_type_options,
            ['rate_type']: 'stable',
            ['segment']: item?.segments[0]?.value || 'N/A',
            ['record_on']: item?.recordOns[0]?.value,
            ['roles']: e.target.value?.includes('Auto') ? ['N/A'] : this.state.controwField?.roles,
            ['link_contract']: false,
            ['refId']: null,
            ['loadingaccessoriesId']: item?.loadingaccessoriesId || null,
          },
          recordOns: appliedOnVal?.recordOns || this.state.recordOns,
          segments: item?.segments || [],
        });
      });

    }
  };

  handleCustomMultiSelect = (value) => {
    let commercial_items = this.state.controwField.commercial_items || [];
    commercial_items = value.map(v => v.id);
    this.setState({ 
      nonCommOpts: value, 
      controwField: { 
        ...this.state.controwField, 
        commercial_items 
      }
    });
  };


  render() {
    return (
      <>
        <ManageContracts
          handlePopover={this.handlePopover}
          handlePopoverClose={this.handlePopoverClose}
          anchorEl={this.state.anchorEl}
          attachment={this.state.attachment}
          modal={this.state.modal}
          action={this.state.action}
          handleOpen={this.handleOpen}
          onClose={this.onClose}
          spanRef={this.spanRef}
          search={this.state.search}
          filter={this.state.filter}
          airline={this.state.airline}
          flight={this.state.flight}
          measure={this.state.measure}
          awbs={this.state.awbs}
          awb={this.state.awb}
          docs={this.state.docs}
          fetchReport={this.fetchReport}
          onChangeSearch={this.onChangeSearch}
          onChangefilter={this.onChangefilter}

          handleExport={this.handleExport}

          onChangecontractFieldEdit={this.onChangecontractFieldEdit}
          onChangechangeDateAndTime={this.changeDateAndTime}
          onChangecontrowField={this.onChangecontrowField}
          onChangecontrateField={this.onChangecontrateField}

          contractFieldEdit={this.state.contractFieldEdit}
          recordOns={this.state.recordOns}
          segments={this.state.segments}
          controwField={this.state.controwField}
          contrateField={this.state.contrateField}

          airlines={this.state.airlineList}
          filteredairlineList={this.state.filteredairlineList}
          combinationAirlines={this.state.combinationAirlines}
          products={this.state.products}
          contract={this.state.contract}
          accessories={this.state.accessories}
          filteredData={this.state.filteredData}

          addContract={this.addContract}
          editContracts={this.editContracts}
          addControw={this.addControw}
          editControw={this.editControw}
          handleCloneContractToPartner={this.cloneContractToPartner}
          handleCloneControwToPartner={this.cloneControwToPartner}
          handleDelete={this.handleDelete}

          contractErrors={this.state.contractErrors}
          contractErrorsEdit={this.state.contractErrorsEdit}
          controwErrors={this.state.controwErrors}
          contrateErrors={this.state.contrateErrors}

          handleDoc={this.handleDoc}

          tab={this.state.tab}
          onChangeTab={this.onChangeTab}
          logs={this.state.logs}
          searchOptions={this.state.searchOptions}
          handleSearchOption={this.handleSearchOption}
          searchFields={this.state.searchFields}
          onChange={this.onChange}
          fetchContract={this.fetchContract}

          expiryTimer={this.state.timer}
          sessionExpired={this.state.sessionExpired}
          startTimer={this.startTimer}
          stopInterval={this.stopInterval}
          handleNumberFormat={this.handleNumberFormat}
          handleOnFocus={this.handleOnFocus}
          dropdown_contracts={this.state.dropdown_contracts}
          commercial_options={this.state.commercial_options}

          handleTableCollapse={this.handleTableCollapse}
          collapse={this.state.collapse}
          buildUp={this.props.buildUp}
          handleDragEnd={this.handleDragEnd}
          modalData={this.state.modalData}
          handleRemark={this.handleRemark}
          handleRemarkClose={this.handleRemarkClose}
          handleRadioChange={this.handleRadioChange}
          appliedOn={this.state.appliedOn}
          handleCustomMultiSelect={this.handleCustomMultiSelect}
          nonCommOpts={this.state.nonCommOpts}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    doc: {
      ...state.doc,
      modal: 'contract'
    },
    stations: state.stations,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setDelete: (data) => dispatch(setDeleteAction(data)),
    setDoc: (data) => dispatch(setDocAction(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageContractsContainer);